module.exports = __webpack_public_path__ + "Roboto-300.c3547b2ec6f5eb324b44.eot";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-300/Roboto-300.eot
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-300/Roboto-300.eot
// module chunks = main styles